<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)"
                  (edit)="onEdit($event)"
                  (remove)="onRemove($event)"
                  [columns]="columns"
                  [dataProvider]="roleService"
                  [title]="title"
  ></data-table>
</page-content>
